<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store
            .dispatch("analysis/getForEdit", this.itemId)
            .then((res) => {
                this.vm = res;
            }).catch(() => { });

        this.$store.dispatch("lookups/getLookups");

    },
    computed: {

        analysisGroups() {
            return [
                ...this.$store.getters["lookups/getLookupByType"](
                    this.$lookupTypes.AnalysisGroups)]
        },
    },
    data() {
        return {
            vm: {
                analysisName: null,
                price: null,
                analysisGroupId: null
            },

        };
    },
    methods: {
        confirm() {
            this.$store
                .dispatch("analysis/edit", { id: this.itemId, payload: this.vm })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },

        back() {

            this.$emit("back");
        },
    },
};
</script>